import { Component, OnInit, Input } from '@angular/core';
import { IAnnouncement } from 'src/modules/shared/interfaces/Iannouncement';
import { Router } from '@angular/router';
import { INews } from 'src/modules/shared/interfaces/INews';
import { TranslateService } from "@ngx-translate/core";
import { daLocale } from 'ngx-bootstrap';

@Component({
  selector: 'app-view-card',
  templateUrl: './view-card.component.html',
  styleUrls: ['./view-card.component.css']
})
export class ViewCardComponent implements OnInit {

  @Input() news: INews;
  currentLang:string;
  DateLang:string;
  constructor(private router: Router,  private translateService: TranslateService) { 
    this.currentLang = this.translateService.currentLang;
  }

  ngOnInit() {
    if(this.currentLang=='en'){
      this.DateLang='en-US' ;
    }
    else{
      this.DateLang='ar-EG';
    }
  }

  readMore(newsId: string){
    this.router.navigate(['/news/details/' + newsId]);
  }

}
